import { render, staticRenderFns } from "./SearchBox1.vue?vue&type=template&id=24c358cf&scoped=true&"
import script from "./SearchBox1.vue?vue&type=script&lang=js&"
export * from "./SearchBox1.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox1.vue?vue&type=style&index=0&id=24c358cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c358cf",
  null
  
)

export default component.exports